// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bX1V4","name":"styles_name__2nJi2","phone":"styles_phone__1AQ-3"};